import { formValueSelector } from 'redux-form';
import { FLEXIBLE_TICKET } from '../../products';
const formSection = FLEXIBLE_TICKET.name;
const getGraphQlSelection = _ref => {
  var _formData$value;
  let {
    state,
    form
  } = _ref;
  const formData = formValueSelector(form)(state, formSection);
  const selectionTraveler = (formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.flatMap(_ref2 => {
    let {
      value
    } = _ref2;
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
      return [];
    }
    return value;
  })) || [];
  if (selectionTraveler.length === 0) {
    return null;
  }
  return {
    productId: String(FLEXIBLE_TICKET.id),
    selectionTraveler
  };
};
export const getDBFGraphQlSelection = _ref3 => {
  var _formData$value2;
  let {
    state,
    form
  } = _ref3;
  const formData = formValueSelector(form)(state, formSection);
  const selectionTraveler = (formData === null || formData === void 0 || (_formData$value2 = formData.value) === null || _formData$value2 === void 0 ? void 0 : _formData$value2.flatMap(_ref4 => {
    let {
      value
    } = _ref4;
    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
      return [];
    }
    return value;
  })) || null;
  if (!selectionTraveler) {
    return null;
  }
  if (selectionTraveler.length === 0) {
    return {
      productId: String(FLEXIBLE_TICKET.id),
      selectionTraveler: []
    };
  }
  return {
    productId: String(FLEXIBLE_TICKET.id),
    selectionTraveler
  };
};
export default getGraphQlSelection;
//# sourceMappingURL=getGraphQlSelection.js.map